

























import { Component, Vue, Emit } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import { Invoice, Receipt, Revenue, RevenueStatus } from '@/services/models'

import CustomerSelector from '@/components/CustomerSelector.vue'
import DatePicker from '@/components/DatePicker.vue'

import { formatters } from '@/helpers/components-utils'

@Component({
  components: {
    DatePicker,
    CustomerSelector,
  },
})
export default class EditReceiptModal extends Vue {

  @Action('firestore/writeReceipt')
  private writeReceipt!: (invoice: Invoice) => Promise<void>

  private isModalOpen: boolean = false

  private title: string = ''

  private localCopy: Receipt = new Receipt()

  public async _commit(value: Invoice, buttonEvent: any) {
    // Validate

    // Write to User
    await this.writeReceipt(value)

    // Really push to event handler
    this.commit(value)
  }

  @Emit()
  public commit(value: Receipt) {
    // emit!
  }

  // PUBLIC Interface

  public edit(receipt: Receipt) {
    this.show()
    this.title = `Edit Receipt: ${receipt.id}`
    this.localCopy = new Receipt(receipt)      // Copy invoice!
  }

  private show() {
    (this.$refs.modalRef as any).show()
  }
}
